<template>
  <div class="period-container" :class="['is-' + state]">
    <span :title="this.period" class="form-control" for="feInputData" @click="showDatePickers = true">{{ this.period }}</span>
    <div v-if="showDatePickers" class="dates">
      <div class="date1">
        <label>De</label>
        <datepicker :model.sync="dateStart" />
      </div>
      <div class="date2">
        <label>Até</label>
        <datepicker :model.sync="dateEnd" />
      </div>
      <d-button class="btn-primary btn btn-block mt-3" @click="apply">
        Selecionar
      </d-button>
      <d-button class="btn-secondary btn btn-block" @click="cancel">
        Cancelar
      </d-button>
  </div>
</div>
</template>

<script>
import Datepicker from '_shared/Datepicker.vue';
import { getDateISO } from '_utils';

export default {
  name: 'between-dates',
  components: { Datepicker },
  props: {
    state: {
      type: String,
      default: null,
    },
    byPeriodStart: {
      type: [Date, String],
      default: () => new Date(),
    },
    byPeriodEnd: {
      type: [Date, String],
      default: () => new Date(),
    },
  },
  data() {
    return {
      showDatePickers: false,
      dateStart: null,
      dateEnd: null,
    };
  },
  computed: {
    period() {
      const formattedStartDate = this.formatDate(this.dateStart);
      const formattedEndDate = this.formatDate(this.dateEnd);
      if (formattedStartDate && formattedEndDate) {
        return `De: ${formattedStartDate} | Até: ${formattedEndDate}`;
      }
      return 'Selecione um periodo';
    },
  },
  mounted() {
    this.dataStart = this.byPeriodStart;
    this.dataEnd = this.byPeriodEnd;
  },
  methods: {
    close() {
      this.showDatePickers = false;
    },
    cancel() {
      this.dateStart = null;
      this.dateEnd = null;
      this.$emit('update:byPeriodStart', this.dateStart);
      this.$emit('update:byPeriodEnd', this.dateEnd);
      this.close();
    },
    apply() {
      const formattedStartDate = getDateISO(this.dateStart);
      const formattedEndDate = getDateISO(this.dateEnd);
      this.$emit('update:byPeriodStart', formattedStartDate);
      this.$emit('update:byPeriodEnd', formattedEndDate);
      this.close();
    },
    formatDate(date) {
      if (!date) return null;

      const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
      const formattedDate = new Intl.DateTimeFormat('pt-BR', options).format(new Date(date));
      return formattedDate;
    },
  },
};
</script>

<style lang='scss'>

.period-container {
  position: relative;
  border: 0;
  box-shadow: none;
  padding: 0;
  span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .dates {
    min-width: 200px;
    width: 100%;
    padding: 5px 15px 15px;
    border: 0;

    position: absolute;
    z-index: 10;

    box-shadow: 0px 2px 6px lighten(#888888, 25%);
    border-radius: 5px;
    margin-top: 0.1rem;
    list-style: none;

    background-color: rgb(255, 255, 255);
  }
}

</style>
